export const ErrorCodes = {
  EMR_NO_DEPARTMENT: {
    code: 403661,
    message: "Please set your department before attempting to export to EMR.",
  },
};
